/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-return-assign */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-case-declarations */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
import BaseService, {
    CATEGORY_PORTAL,
    ERROR_MESSAGE_TOKEN_INVALID,
    ERROR_MESSAGE_UNEXPECTED,
    HTTP_STATUS_BAD_REQUEST,
    HTTP_STATUS_FORBIDDEN,
    HTTP_STATUS_NO_CONTENT,
    HTTP_STATUS_OK,
    HTTP_STATUS_UNAUTHORIZED,
} from "./core/BaseService";

export interface UserDetailPayload {
    fileData: string;
    fileType: string;
    lang: string;
    familyNameJa: string;
    password: string;
    rePassword: string;
    firstNameJa: string;
    familyNameKanaJa: string;
    firstNameKanaJa: string;
    addressJa: string;
    homePhone: string;
    faxNumber: string;
    email1: string;
    email2: string;
    careerMemoJa: string;
    countryCode: string;
    timeZone: string;
    lederUserId: string;
    deleteImage: boolean;
}

export interface Organization {
    companyId: string;
    id: string;
    name: string;
}
export interface UserOrganization {
    additionalFlg: boolean;
    companyId: string;
    orgId: string;
    orgName: string;
    titleId: string;
    titleName: string;
}
export interface UserDetailResponse {
    addressEn: string;
    addressJa: string;
    addressZh: string;
    applyFlg: number;
    birthday: string;
    careerMemoEn: string;
    careerMemoJa: string;
    careerMemoZh: string;
    certification: number;
    countryCode: string;
    createGroupFlg: number;
    deleteImage: boolean;
    email1: string;
    email2: string;
    employeeCategoryId: string;
    employeeCategoryName: string;
    existsImageFile: boolean;
    familyNameEn: string;
    familyNameJa: string;
    familyNameZh: string;
    familyNameKanaEn: string;
    familyNameKanaJa: string;
    familyNameKanaZh: string;
    faxNumber: string;
    firstNameEn: string;
    firstNameJa: string;
    firstNameZh: string;
    firstNameKanaEn: string;
    firstNameKanaJa: string;
    firstNameKanaZh: string;
    groups: Organization[];
    homePhone: string;
    idFlg: string;
    lang: string;
    lederUserId: string;
    lederUserName: string;
    loginId: string;
    noteEn: string;
    noteJa: string;
    noteZh: string;
    occupationId: string;
    occupationName: string;
    officeId: string;
    officeName: string;
    orgs: Organization[];
    password: string;
    primaryOrgId: string;
    seibetu: string;
    timeZone: string;
    workStartDate: string;
    userOrgs: UserOrganization[];
    accessLevelId1: string;
    accessLevelPatternId1: string;
    accessLevelId2: string;
    accessLevelPatternId2: string;
}

// パスワードポリシーに違反しているかの判定で利用
const passwordErrorMessage = [
    "ログインIDと同じ文字列のパスワードは禁止されています。",
    "パスワードの長さが指定された文字数以下です。セキュリティ確保のため指定文字数以上の長さのパスワードを設定してください。",
    "パスワード変更時に変更前のパスワードが指定されました。新しいパスワードを指定してください。",
    "パスワードは必ず英字と数字を混在させて、設定してください。",
];
const ERROR_PASSWORD_POLICY = "ERROR_PASSWORD_POLICY";

class UserDetailService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "userDetail");
    }

    public async getUserDetail(resolved: (response: UserDetailResponse) => void, rejected: (error: any) => void) {
        await super.getJSON((json: any) => {
            const response = json as UserDetailResponse;
            resolved(response);
        }, rejected);
    }

    public async saveUserDetail(payload: Partial<UserDetailPayload>, resolved: (result: unknown) => void, rejected: (error: any) => void) {
        await super.postJSON(payload, resolved, rejected);
    }

    protected async errorHandler(response: Response): Promise<Response> {
        const { status } = response;
        if (response.ok && (status === HTTP_STATUS_OK || status === HTTP_STATUS_NO_CONTENT)) {
            return response;
        }

        const json = await response.json();
        switch (status) {
            case HTTP_STATUS_UNAUTHORIZED:
            case HTTP_STATUS_FORBIDDEN:
                throw Error(ERROR_MESSAGE_TOKEN_INVALID);

            case HTTP_STATUS_BAD_REQUEST:
                json.errors.forEach((responseObj: any) => {
                    const { detail } = responseObj;
                    const passwordJudgement = passwordErrorMessage.some((pwErrorItem) => pwErrorItem === detail);
                    if (passwordJudgement === true) {
                        throw Error(`${ERROR_PASSWORD_POLICY}:${detail}`);
                    }
                });

                const message = (json.errors || []).map((e: any) => `${e.item}: ${e.detail}`).join("\n");
                throw Error(message);

            default:
                throw Error(ERROR_MESSAGE_UNEXPECTED);
        }
    }
}

export default UserDetailService;
